module.exports = __webpack_public_path__ + "img/banner.5e359017.jpg";